// Opening the Kanban on a given project (Work's project cards): the project
// is left here, then the board opens and takes it.
let nextProject = null
export const openKanbanOn = (project, open) => { nextProject = project || null; if (open) open() }
export const takeKanbanProject = () => { const p = nextProject; nextProject = null; return p }
